import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {MatError, MatHint, MatOption, MatSelect} from '@angular/material/select';
import {FormControl, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatInput} from '@angular/material/input';
import {ErrorMatcher} from '../../classes/error-matcher/error-matcher';
import {ContactService} from '../../services/contact/contact.service';
import {Subject, takeUntil} from 'rxjs';
import {InfoMessageService} from '../../services/infomessage/infomessage.service';
import {Router} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-contact',
    imports: [
        MatSelect,
        ReactiveFormsModule,
        MatOption,
        MatInput,
        MatHint,
        MatError,
        FormsModule
    ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.sass'
})
export class ContactComponent implements OnInit {
    private destroy$ = new Subject<void>();
    matcher = new ErrorMatcher();
    header = new FormControl('', Validators.required);
    senderMail = new FormControl('', [Validators.required, Validators.email]);
    reason = new FormControl('', Validators.required);
    firstName = new FormControl('', Validators.required);
    lastName = new FormControl('', Validators.required);
    captchaInput: string = '';

    code: string = '';
    resultCode: string = '';

    checkCaptchaValue = false;
    constructor(
        private contactService: ContactService,
        private infoMessageService: InfoMessageService,
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: object
    ) {
    }

    ngOnInit() {
        this.createCaptcha();
    }

    sendRequest() {
        if (this.header.invalid && this.senderMail.invalid && this.reason.invalid && this.firstName.invalid && this.lastName.invalid) {
            this.header.markAsTouched();
            this.senderMail.markAsTouched();
            this.reason.markAsTouched();
            this.firstName.markAsTouched();
            this.lastName.markAsTouched();
            return;
        }
        if(!this.checkCaptcha()) {
            this.infoMessageService.createMessage('Sind Sie etwa ein Roboter ? Bitte geben Sie den richtigen Code ein', 'info');
            return;
        }
        this.postRequest();
    }

    checkCaptcha(): boolean {
        if (this.captchaInput === this.resultCode) {
            this.checkCaptchaValue = true;
            return true;
        } else {
            this.checkCaptchaValue = false;
            return false;
        }
    }

    reloadCaptcha(): void {
        this.createCaptcha();
    }

    private postRequest() {
        this.contactService.postContactForm({header: this.header.value, email: this.senderMail.value, reason: this.reason.value, firstName: this.firstName.value, lastName: this.lastName.value})
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                    this.router.navigate(['/home']);
                    this.infoMessageService.createMessage('Anfrage erfolgreich gesendet', 'success');
                },
                error: (error) => {
                    this.infoMessageService.createMessage('Anfrage fehlgeschlagen', 'error');
                }
            });
    }

    // TODO Seperate Component
    private createCaptcha(): void {
        // Generate a random captcha code.
        const char = Math.random().toString(24).substring(2, 6) +
            Math.random().toString(24).substring(2, 4).toUpperCase();
        this.code = this.resultCode = char;

        setTimeout(() => {
            if (isPlatformBrowser(this.platformId)) {
                const canvas = document.getElementById('captcha') as HTMLCanvasElement;
                if (canvas && canvas.getContext) {
                    const ctx = canvas.getContext('2d');

                    if (ctx) {
                        // Clear the entire canvas.
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        ctx.beginPath();

                        // Set up text styling.
                        ctx.font = "bold 48px Arial"; // Using pixels; adjust as needed.
                        ctx.fillStyle = 'lightgray';
                        ctx.textAlign = 'center';      // Center text horizontally.
                        ctx.textBaseline = 'middle';   // Center text vertically.

                        // Draw the captcha text at the center of the canvas.
                        ctx.fillText(this.code, canvas.width / 2, canvas.height / 2);

                        // Draw random lines for added security.
                        ctx.strokeStyle = 'black';
                        for (let i = 0; i < 60; i++) {
                            ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
                            ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
                        }
                        ctx.stroke();
                    }
                }
            }
        }, 100);
    }

}
